import styled from 'styled-components'

export const ContainerBox = styled.div `
margin-top: 45px;
margin-bottom: 45px; 
padding-top: 20px;
background: white;
border: 1px solid rgb(0,0,0,15%);
@media (max-width: 990px) {
    margin-top: 0px;
}

`


export const Heading = styled.h2 `
font-size: 20px;
color: #212D3D;
  padding-left: 15px;
  @media (max-width: 500px) {
    font-size: 20px;
  }
  color: #000000;
`


// WEBPACK FOOTER //
// /src/components/admin/AdminStyle.js